import React from "react";
// import './mathsubject.css';
import PurchaseHistory from "../components/PurchaseHistory";
import ForTeacherMenu from "../components/ForTeacherMenu";

const TeacherPurchaseHistory = () => {
       return (
              <div className="App-full-row-container">
                     <div className="left-menu-box-1" style={{fontWeight:"bolder", color:"orange" ,marginTop:"10px", marginBottom:"1px", marginLeft:"30px"}}>
                            <ForTeacherMenu />
                     </div>
                     <div className="content-box-1">
                            <PurchaseHistory />
                     </div>
              </div>
       )
}

export default TeacherPurchaseHistory;